import React from "react";
import CheckInDetailScreen from "./CheckInDetailScreen";

export default () => {
  return <CheckInDetailScreen isOfficeStaff />;
};
